import * as React from "react";
import { useFormContext } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
import { AddressLookup } from "../../../../../../modules/AddressLookup/components/modules/AddressLookup/components/AddressLookup.js";
import { useLoggedInCheckout } from "../../../../../context/LoginExpressCheckout/context/context.js";
import { validateInputField } from "../../../../../../modules/AddressLookup/utils/modules/AddressLookup/utils/validate-input-field.js";
import { mapDataToFormValues } from "../../../../../../modules/AddressLookup/utils/modules/AddressLookup/utils/map-data-to-form-values.js";
import { useCheckoutSettings } from "../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const AddressLookupWithoutStore = ({
  inputFieldName = "streetName",
  errorMessage: initialErrorMessage,
  maxLength,
  validations,
  validationsWithErrorMessages,
  label
}) => {
  const { userDetailsState } = useLoggedInCheckout();
  const [isTouched, setIsTouched] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(initialErrorMessage);
  const { addressLookup } = useCheckoutSettings();
  const { name, onChange, getInitialState, setFieldState } = useFormContext();
  const initialState = getInitialState && getInitialState(inputFieldName);
  const currentForm = React.useMemo(
    () => name ? userDetailsState[name] : {},
    [name, userDetailsState]
  );
  const { country } = useIntl();
  const validateInput = React.useCallback(
    (value, initialErrorMessage2 = "") => {
      const { isValid, errorMessage: errorMessage2 } = validateInputField(
        true,
        value,
        initialErrorMessage2,
        validations,
        validationsWithErrorMessages,
        maxLength
      );
      setErrorMessage(errorMessage2);
      return isValid;
    },
    [maxLength, validations, validationsWithErrorMessages]
  );
  const updateForm = React.useCallback(
    (value, initialRender) => {
      if (onChange) {
        onChange({
          name: inputFieldName,
          value,
          isTouched: initialRender ? !!initialState?.isTouched : true,
          isValid: validateInput(value)
        });
      }
    },
    [onChange, inputFieldName, initialState?.isTouched, validateInput]
  );
  const updateStore = React.useCallback(
    (prefillData) => {
      prefillData && Object.entries(prefillData).forEach(([key, value]) => {
        const fieldState = getInitialState?.(key);
        if (fieldState) {
          setFieldState?.({ ...fieldState, value });
        }
      });
    },
    [getInitialState, setFieldState]
  );
  const handleOnResult = React.useCallback(
    (data) => {
      const formattedData = mapDataToFormValues(data, addressLookup);
      updateStore(formattedData);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addressLookup, currentForm, updateStore, country]
  );
  const handleIsTouched = React.useCallback(() => {
    setIsTouched(true);
  }, []);
  const handleOnChange = React.useCallback(
    (initialState2) => {
      if (onChange) {
        onChange({
          name: inputFieldName,
          value: initialState2.value,
          isTouched: initialState2.isTouched || isTouched || Boolean(initialState2.value),
          isValid: validateInput(initialState2.value, initialErrorMessage)
        });
      }
    },
    [initialErrorMessage, inputFieldName, isTouched, onChange, validateInput]
  );
  React.useEffect(() => {
    if (!initialState) {
      return;
    }
    handleOnChange(initialState);
  }, [initialState?.isTouched, initialState?.value, initialState?.isValid]);
  React.useEffect(() => {
    !currentForm?.streetName && updateForm("", true);
  }, []);
  return /* @__PURE__ */ React.createElement(
    AddressLookup,
    {
      hasDisplayError: !Boolean(initialState?.isValid) && (Boolean(initialState?.isTouched) || isTouched),
      isDisplayIsValid: Boolean(initialState?.isValid) && (Boolean(initialState?.isTouched) || isTouched),
      errorMessage,
      inputFieldName,
      label,
      setIsTouched: handleIsTouched,
      onResult: handleOnResult,
      streetName: initialState?.value || "",
      updateForm
    }
  );
};
export {
  AddressLookupWithoutStore
};
//# sourceMappingURL=AddressLookUpWithoutState.js.map
